export default function About() {
  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-blue-50 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <p className="text-blue-500 font-semibold text-sm uppercase tracking-wider mb-2">ABOUT</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">製品について</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl shadow-xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                ウルトラファインバブル発生ノズル<br />
                <span className="text-blue-500">『UFB DUAL™』</span>とは？
              </h3>
              <p className="text-gray-700 leading-relaxed mb-6">
                特許技術により水道機器認証と飲用適水テストに合格している、ウルトラファインバブル水の生成ノズルです。シャワーヘッドや洗濯機を変えることなく、水道の配管に取り付けることでお家の水道を"まるごと"ウルトラファインバブル水に変えることができます。
              </p>
              <p className="text-gray-700 leading-relaxed mb-8">
                導入実績は、世界15カ国で10,000箇所以上（2025年1月時点）。詳しい特徴は、以下の「詳細はこちら」からご覧ください。
              </p>

              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-500 text-white rounded-full mr-4 flex-shrink-0">
                    <i className="ri-check-line"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">特許技術</h4>
                    <p className="text-sm text-gray-600">水道機器認証と飲用適水テスト合格</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-500 text-white rounded-full mr-4 flex-shrink-0">
                    <i className="ri-check-line"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">簡単設置</h4>
                    <p className="text-sm text-gray-600">水道配管に取り付けるだけで家全体に効果</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="w-8 h-8 flex items-center justify-center bg-blue-500 text-white rounded-full mr-4 flex-shrink-0">
                    <i className="ri-check-line"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">豊富な実績</h4>
                    <p className="text-sm text-gray-600">世界15カ国で10,000箇所以上の導入実績</p>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <a
                  href="#contact"
                  className="inline-block bg-blue-500 text-white px-8 py-3 rounded-full hover:bg-blue-600 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap"
                >
                  詳細はこちら
                </a>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="transform hover:scale-105 transition-transform duration-300">
              <img
                src="https://ufbdual.com/wp-content/uploads/2021/01/about01.jpg"
                alt="UFB DUAL製品"
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl">
              <p className="text-4xl font-bold text-blue-500 mb-1">10,000+</p>
              <p className="text-sm text-gray-600">導入実績</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
